exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".feature-detail{width:333px;margin:0 0 15px 0;box-shadow:0px 2px 3px rgba(0,0,0,.1607843137);border-radius:4px;background-color:#fff;min-height:166px;padding:8px}.feature-detail ul{padding:0;margin:0}.feature-detail ul li{display:flex;margin-bottom:15px;padding:0 25px;font-size:.875rem;font-weight:500;line-height:17px;list-style:none}.feature-detail ul li .icon-container{display:flex;height:36px;width:36px;margin-right:10px;margin-bottom:6px;flex-shrink:0;align-items:center;justify-content:center;border-radius:50%}.feature-detail ul li .icon-container svg{width:24px;height:24px}.feature-detail ul li .feature-card-text{display:flex;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/Appointment/CustomAppointmentCard.scss
// module id = 8120
// module chunks = 13